module.exports = __webpack_public_path__ + "img/green-tourism.c00e5cad.png";